import "./App.css";
import "./Styles/fontfamily.css";

import NavbarComp from "./Component/NavbarComp";
import { FooterComp } from "./Component/FooterComp";
import GdprModal from "./Pages/GDPRModal";
import MainRoutes from "./Pages/MainRoutes";

function App() {
  return (
    <>
      <NavbarComp />
      <GdprModal />
      <MainRoutes />
      <FooterComp />
    </>
  );
}

export default App;
